export default {
  format (date, fmt) {
    date *= 1
    if (!date || date === '0') {
      return ''
    }
    date = new Date(date)
    var options = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (var o in options) {
      if (new RegExp('(' + o + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (options[o]) : (('00' + options[o]).substr(('' + options[o]).length)))
      }
    }
    return fmt
  }
}



// WEBPACK FOOTER //
// ./src/util/date.js